"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _underscore = require("underscore");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var _UIOverlay = _interopRequireDefault(require("UIComponents/overlay/UIOverlay"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _SimpleTextInputWithValidation = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleTextInputWithValidation"));

var _FileUploadManager = _interopRequireDefault(require("../FileManager/FileUploadManager"));

var _CosPageSelector = _interopRequireDefault(require("./CosPageSelector"));

var _MeetingsSelector = _interopRequireDefault(require("./MeetingsSelector"));

var _EventSelector = _interopRequireDefault(require("./EventSelector"));

var _RedirectButtonType = _interopRequireDefault(require("lead-flows-ui/constants/RedirectButtonType"));

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _DynoValidationUtils = require("lead-flows-ui/utils/Validation/DynoValidationUtils");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var _DynoErrorTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoErrorTypes"));

var langKey = function langKey(suffix) {
  return "leadFlowEditor.leadFlowThankYouMessage." + suffix;
};

var BUTTON_MAX_LENGTH = 80;

var RedirectOptions =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RedirectOptions, _PureComponent);
  (0, _createClass2.default)(RedirectOptions, null, [{
    key: "propTypes",
    get: function get() {
      return {
        addValidationError: _react.default.PropTypes.func.isRequired,
        eventTitle: _react.default.PropTypes.string,
        eventDetails: _react.default.PropTypes.string,
        eventLocation: _react.default.PropTypes.string,
        eventDates: _react.default.PropTypes.object,
        hasCOSAccess: _react.default.PropTypes.bool.isRequired,
        redirectButtonText: _react.default.PropTypes.string,
        redirectButtonType: _react.default.PropTypes.string,
        redirectUrl: _react.default.PropTypes.string,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        removeAllOtherErrors: _react.default.PropTypes.func,
        updateDyno: _react.default.PropTypes.func.isRequired,
        validation: _react.default.PropTypes.object.isRequired,
        allGates: _react.default.PropTypes.array.isRequired,
        isFromCallout: _react.default.PropTypes.bool,
        calloutButtonType: _react.default.PropTypes.string,
        hasForm: _react.default.PropTypes.bool
      };
    }
  }]);

  function RedirectOptions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RedirectOptions);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RedirectOptions).call(this, props));
    _this.state = {
      url: '',
      error: null
    };
    _this.handleEnableDisableChange = _this.handleEnableDisableChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRedirectUrlChange = _this.handleRedirectUrlChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRedirectUrlBlur = _this.handleRedirectUrlBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRedirectButtonTextChange = _this.handleRedirectButtonTextChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateDyno = _this.updateDyno.bind((0, _assertThisInitialized2.default)(_this));
    _this.getOption = _this.getOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.validate = _this.validate.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeAllOtherErrors = _this.removeAllOtherErrors.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(RedirectOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var error = this.validate();
      this.updateValidationError(error);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var error = this.validate();
      this.updateValidationError(error);
    }
  }, {
    key: "getOption",
    value: function getOption(changes) {
      var _this$props = this.props,
          redirectUrl = _this$props.redirectUrl,
          redirectButtonType = _this$props.redirectButtonType,
          calloutButtonType = _this$props.calloutButtonType,
          isFromCallout = _this$props.isFromCallout;
      return (0, _extends2.default)({
        redirectUrl: redirectUrl,
        redirectButtonType: isFromCallout ? calloutButtonType : redirectButtonType
      }, changes);
    }
  }, {
    key: "validate",
    value: function validate() {
      var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var redirectOption = this.getOption(changes);
      var error = (0, _DynoValidationUtils.validateRedirectOption)(redirectOption, langKey("error"));
      return error;
    }
  }, {
    key: "updateValidationError",
    value: function updateValidationError(errors) {
      var _this$props2 = this.props,
          removeValidationError = _this$props2.removeValidationError,
          addValidationError = _this$props2.addValidationError;
      removeValidationError('redirectUrl');

      if (errors.length) {
        errors.forEach(function (error) {
          return addValidationError.apply(null, error);
        });
      }
    }
  }, {
    key: "updateDyno",
    value: function updateDyno(changes) {
      var autosave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.props.updateDyno(changes, autosave);
    }
  }, {
    key: "removeAllOtherErrors",
    value: function removeAllOtherErrors() {
      var removeAllOtherErrors = this.props.removeAllOtherErrors;
      Object.keys(_DynoErrorTypes.default).forEach(function (error) {
        return removeAllOtherErrors(_DynoErrorTypes.default[error]);
      });
    }
  }, {
    key: "changeButtonType",
    value: function changeButtonType(newType) {
      var _this$props3 = this.props,
          removeValidationError = _this$props3.removeValidationError,
          redirectUrl = _this$props3.redirectUrl,
          redirectButtonType = _this$props3.redirectButtonType,
          calloutButtonType = _this$props3.calloutButtonType,
          isFromCallout = _this$props3.isFromCallout;
      var optionsState = (0, _underscore.omit)(this.props, ['updateDyno', 'addValidationError', 'removeVaxlidationError']);
      var newState = Object.assign({}, this.state, optionsState);
      var changes = {};

      if (isFromCallout) {
        changes.calloutButtonType = newType;

        if (isFromCallout !== _RedirectButtonType.default.GO_TO_FORM_STEP) {
          changes.redirectButtonType = _RedirectButtonType.default.DISABLED;
          this.removeAllOtherErrors();
        }

        (0, _eventsTrackerUtils.trackEditorInteraction)('callout-redirect-button-type-change', {
          newRedirectButtonType: newType
        });
      } else {
        changes.redirectButtonType = newType;
        (0, _eventsTrackerUtils.trackEditorInteraction)('redirect-button-type-change', {
          newRedirectButtonType: newType
        });
      }

      changes.redirectUrl = null;

      if (newType === _RedirectButtonType.default.DISABLED) {
        this.setState(newState);
        changes.redirectButtonText = null;
      }

      if (newType !== _RedirectButtonType.default.HTTP_LINK) {
        if ((isFromCallout ? calloutButtonType : redirectButtonType) === _RedirectButtonType.default.HTTP_LINK) {
          removeValidationError('redirectUrl');
          this.setState({
            url: redirectUrl
          });
        }
      } else {
        if ((0, _ValidationUtils.isValidUrl)(this.state.url, false)) {
          changes.redirectUrl = this.state.url;
        }
      }

      this.updateDyno(changes);
    }
  }, {
    key: "handleRedirectUrlChange",
    value: function handleRedirectUrlChange(_ref) {
      var value = _ref.target.value;
      var redirectUrl = value.trim();
      this.updateDyno({
        redirectUrl: redirectUrl
      });
    }
  }, {
    key: "handleRedirectUrlBlur",
    value: function handleRedirectUrlBlur(_ref2) {
      var value = _ref2.target.value;
      var redirectUrl = value.trim();
      this.updateDyno({
        redirectUrl: redirectUrl
      });
      var error = this.validate();
      this.updateValidationError(error);
    }
  }, {
    key: "handleRedirectButtonTextChange",
    value: function handleRedirectButtonTextChange(_ref3) {
      var value = _ref3.target.value;
      var _this$props4 = this.props,
          addValidationError = _this$props4.addValidationError,
          removeValidationError = _this$props4.removeValidationError;
      this.updateDyno({
        redirectButtonText: value
      });

      if (value.length > BUTTON_MAX_LENGTH) {
        addValidationError('redirectButtonText', langKey('error.redirectButtonExceedsLength'));
      } else {
        removeValidationError('redirectButtonText');
      }
    }
  }, {
    key: "handleEnableDisableChange",
    value: function handleEnableDisableChange(_ref4) {
      var checked = _ref4.target.checked;
      var changes = Object.assign({}, this.state);

      if (checked) {
        if (this.state.redirectButtonType) {
          delete changes.url;
          this.updateDyno(changes);
        } else {
          this.changeButtonType(_RedirectButtonType.default.HTTP_LINK);
        }
      } else {
        this.changeButtonType(_RedirectButtonType.default.DISABLED);
      }
    }
  }, {
    key: "renderEditor",
    value: function renderEditor() {
      var _this$props5 = this.props,
          validation = _this$props5.validation,
          redirectUrl = _this$props5.redirectUrl,
          redirectButtonType = _this$props5.redirectButtonType,
          calloutButtonType = _this$props5.calloutButtonType,
          addValidationError = _this$props5.addValidationError,
          removeValidationError = _this$props5.removeValidationError,
          eventTitle = _this$props5.eventTitle,
          eventDetails = _this$props5.eventDetails,
          eventLocation = _this$props5.eventLocation,
          eventDates = _this$props5.eventDates,
          allGates = _this$props5.allGates,
          isFromCallout = _this$props5.isFromCallout;

      var linkInput = _react.default.createElement(_SimpleTextInputWithValidation.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: langKey('redirectToUrl')
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(validation, 'redirectUrl'),
        name: "redirectUrl",
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.redirectUrl),
        value: redirectUrl,
        placeholder: 'http://www.website.com/blog',
        onChange: this.handleRedirectUrlChange,
        onBlur: this.handleRedirectUrlBlur,
        required: true
      });

      var meetingInput = _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: langKey('meetingPicker')
        }),
        error: !(0, _ValidationUtils.isValid)(validation, 'redirectUrl'),
        validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.redirectUrl)
      }, _react.default.createElement(_MeetingsSelector.default, {
        redirectUrl: redirectUrl,
        updateDyno: this.updateDyno
      }));

      var fileInput = _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: langKey('filePicker')
        }),
        error: !(0, _ValidationUtils.isValid)(validation, 'redirectUrl'),
        validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.redirectUrl)
      }, _react.default.createElement(_FileUploadManager.default, {
        fileUrl: redirectUrl,
        updateDyno: this.updateDyno
      }));

      var cosPageInput = _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: langKey('cosPicker')
        }),
        error: !(0, _ValidationUtils.isValid)(validation, 'redirectUrl'),
        validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.redirectUrl)
      }, _react.default.createElement(_CosPageSelector.default, {
        redirectUrl: redirectUrl,
        updateDyno: this.updateDyno
      }));

      var calendarInput = _react.default.createElement(_UIFormControl.default, {
        className: "redirect-options__calendar",
        error: !(0, _ValidationUtils.isValid)(validation, 'redirectUrl'),
        validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.redirectUrl)
      }, _react.default.createElement(_EventSelector.default, {
        validation: validation,
        redirectUrl: redirectUrl,
        addValidationError: addValidationError,
        removeValidationError: removeValidationError,
        updateDyno: this.updateDyno,
        eventTitle: eventTitle,
        eventDetails: eventDetails,
        eventLocation: eventLocation,
        eventDates: eventDates,
        allGates: allGates
      }));

      var redirectEditor;
      var redirectOrCallout = isFromCallout ? calloutButtonType : redirectButtonType;

      switch (redirectOrCallout) {
        case _RedirectButtonType.default.HTTP_LINK:
          redirectEditor = linkInput;
          break;

        case _RedirectButtonType.default.COS_PAGE_LINK:
          redirectEditor = cosPageInput;
          break;

        case _RedirectButtonType.default.FILE_DOWNLOAD:
          redirectEditor = fileInput;
          break;

        case _RedirectButtonType.default.MEETINGS_LINK:
          redirectEditor = meetingInput;
          break;

        case _RedirectButtonType.default.CALENDAR_LINK:
          redirectEditor = calendarInput;
          break;

        default:
          redirectEditor = null;
          break;
      }

      return redirectEditor;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this2 = this;

      var _this$props6 = this.props,
          redirectButtonType = _this$props6.redirectButtonType,
          hasCOSAccess = _this$props6.hasCOSAccess,
          isFromCallout = _this$props6.isFromCallout,
          calloutButtonType = _this$props6.calloutButtonType;
      var buttonType = isFromCallout ? calloutButtonType : redirectButtonType;
      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: langKey('redirectButtonType')
        })
      }, _react.default.createElement("div", null, isFromCallout && _react.default.createElement(_UIRadioInput.default, {
        checked: buttonType === _RedirectButtonType.default.GO_TO_FORM_STEP,
        name: "selectedInputType",
        onChange: function onChange() {
          return _this2.changeButtonType(_RedirectButtonType.default.GO_TO_FORM_STEP);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('leadToForm')
      })), _react.default.createElement(_UIRadioInput.default, {
        checked: buttonType === _RedirectButtonType.default.HTTP_LINK,
        name: "selectedInputType",
        onChange: function onChange() {
          return _this2.changeButtonType(_RedirectButtonType.default.HTTP_LINK);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('urlOption')
      })), hasCOSAccess ? _react.default.createElement(_UIRadioInput.default, {
        checked: buttonType === _RedirectButtonType.default.COS_PAGE_LINK,
        name: "selectedInputType",
        onChange: function onChange() {
          return _this2.changeButtonType(_RedirectButtonType.default.COS_PAGE_LINK);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('cosOption')
      })) : null, _react.default.createElement(_UIRadioInput.default, {
        checked: buttonType === _RedirectButtonType.default.FILE_DOWNLOAD,
        name: "selectedInputType",
        onChange: function onChange() {
          return _this2.changeButtonType(_RedirectButtonType.default.FILE_DOWNLOAD);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('downloadOption')
      })), _react.default.createElement(_UIRadioInput.default, {
        checked: buttonType === _RedirectButtonType.default.MEETINGS_LINK,
        name: "selectedInputType",
        onChange: function onChange() {
          return _this2.changeButtonType(_RedirectButtonType.default.MEETINGS_LINK);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('meetingOption')
      })), _react.default.createElement(_UIRadioInput.default, {
        className: "redirect-options__calendar-link",
        checked: buttonType === _RedirectButtonType.default.CALENDAR_LINK,
        name: "selectedInputType",
        onChange: function onChange() {
          return _this2.changeButtonType(_RedirectButtonType.default.CALENDAR_LINK);
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('calendarOption')
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          redirectButtonType = _this$props7.redirectButtonType,
          redirectButtonText = _this$props7.redirectButtonText,
          validation = _this$props7.validation,
          isFromCallout = _this$props7.isFromCallout;

      var textInput = _react.default.createElement(_SimpleTextInputWithValidation.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: langKey('redirectButtonText')
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(validation, 'redirectButtonText'),
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.redirectButtonText),
        value: redirectButtonText || '',
        onChange: this.handleRedirectButtonTextChange,
        required: false
      });

      return _react.default.createElement("div", {
        className: "redirect-options"
      }, !isFromCallout && _react.default.createElement(_UIFormControl.default, {
        className: "redirect-button-checkbox-container"
      }, _react.default.createElement(_UICheckbox.default, {
        name: "redirectEnabled",
        defaultChecked: redirectButtonType !== _RedirectButtonType.default.DISABLED,
        onChange: this.handleEnableDisableChange
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('redirectButtonEnabled')
      }))), _react.default.createElement(_UIFieldset.default, {
        overlay: !isFromCallout && redirectButtonType === _RedirectButtonType.default.DISABLED ? _react.default.createElement(_UIOverlay.default, {
          width: 250
        }, _react.default.createElement("p", {
          className: "redirect-button-overlayText"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: langKey('redirectOptionsHidden')
        }))) : null
      }, !isFromCallout && textInput, this.renderOptions(), this.renderEditor()));
    }
  }]);
  return RedirectOptions;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  var dyno = (0, _Dynos.getEditableDyno)(state);
  return {
    hasCOSAccess: (0, _Scopes.hasScope)(state, 'content-access'),
    eventTitle: dyno.eventTitle,
    eventDetails: dyno.eventDetails,
    eventLocation: dyno.eventLocation,
    eventDates: dyno.eventDates,
    redirectUrl: dyno.redirectUrl,
    redirectButtonText: dyno.redirectButtonText,
    redirectButtonType: dyno.redirectButtonType,
    calloutButtonType: dyno.calloutButtonType,
    hasForm: (0, _Dynos.getHasForm)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return (
    /*dispatch*/
    {}
  );
};

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RedirectOptions));

exports.default = _default;
module.exports = exports.default;